import * as userApi from "../../api/user"
import * as types from "../mutation-types"
import * as helper from "../../utils/helper"
import { ACCOUNT_TYPE } from "../../constants/invoice"
import {
  addParam,
  delParam,
  getParam,
  getSessionCookie,
  parsePskeyQQLogin,
  parseQQLogin,
  parseWechatLogin,
  session_dummy,
  session_wxbean,
  session_third,
  cookies
} from "@tencent/midas-util"
import Raven from "raven-js"
import { MsdkAccount } from "../../common/MsdkAccount"
import { CommonAccount } from "../../common/CommonAccount"
const Promise = require("es6-promise").Promise

import "@tencent/midas-vue-util/lib/MidasH5Login/css/MidasH5Login.css"
import MidasH5Login from "@tencent/midas-vue-util/lib/MidasH5Login/MidasH5Login.js"

const state = {
  sessionObj: {},
  //0-dummy,1-qq,2-wx
  accountType: 0,
  isWX: userApi.isWX(),
  isQQ: userApi.isQQ(),
  isWxMini: userApi.isWxMini(),
  nickName: "",
  avatar: "",
  embed: getParam("embed")
}

const getters = {
  sessionObj: state => state.sessionObj,
  accountType: state => state.accountType,
  isWX: state => state.isWX,
  isQQ: state => state.isQQ,
  isWxMini: state => state.isWxMini,
  isBrowser: state => {
    return !state.isWX && !state.isQQ
  },
  nickName: state => state.nickName,
  avatar: state => state.avatar,
  embed: state => state.embed,
  // 第三方登录态
  thirdLoginState() {
    return {
      openid: getParam("openid"),
      openkey: getParam("openkey"),
      session_id: getParam("sessionid"),
      session_type: getParam("sessiontype"),
      wx_appid: getParam("wxAppid2"),
      qq_appid: getParam("qq_appid"),
      offer_id: getParam("offer_id")
    }
  }
}

const actions = {
  /**
   * 区分嵌入模式embed
   * 如果嵌入模式，则读取cookie中的midas登录态；如果cookie中没有登录态或者登录态过期，则拉起登录；登录后不种cookie
   * 如果不是embed模式，不读midas登录态，但可以种cookie
   * @param getters
   * @param dispatch
   */
  getLoginState({ getters, dispatch }) {
    let accountParam = getParam("account")
    if (getters.embed) {
      let cookieState = getSessionCookie()
      //无cookie||游客登录态
      if (!cookieState || userApi.getSessionType(cookieState) === "dummy") {
        // 如果有account参数，则说明是cookie登录态有问题，用户主动拉起H5登录
        // 微信qq内不认account（嵌入页面不应该有account参数，同时以防浏览器地址分享到客户端，account参数混淆代码去取登录态）
        // 未取到midas登录态，拉起登录 || 登录态失效
        // 如果是非QQorWX环境下，拉起的H5登录
        if (getters.isBrowser) {
          if (accountParam) {
            return new Promise(async (resolve, reject) => {
              if (accountParam === "qq") {
                let loginState = await parsePskeyQQLogin({ s_url: location.href })

                if (loginState) {
                  resolve(loginState)
                } else {
                  dispatch("midasH5Login")
                  resolve(
                    new session_dummy({
                      openid: "xxx",
                      openkey: "openkey"
                    })
                  )
                }
              } else if (accountParam === "wx") {
                // 浏览器下微信登录后还有account参数？ 会不会被授权干掉#后参数
                let loginState = parseWechatLogin()

                if (loginState) {
                  resolve(loginState)
                } else {
                  dispatch("midasH5Login")
                  resolve(
                    new session_dummy({
                      openid: "xxx",
                      openkey: "openkey"
                    })
                  )
                }
              }
            })
          } else {
            dispatch("midasH5Login")
            return new Promise((resolve, reject) => {
              resolve(
                new session_dummy({
                  openid: "xxx",
                  openkey: "openkey"
                })
              )
            })
          }
        } else {
          // 在QQorWX内
          return new Promise(async (resolve, reject) => {
            let loginState = getters.isQQ ? await parsePskeyQQLogin({ s_url: location.href }) : parseWechatLogin()

            if (!loginState)
              loginState = new session_dummy({
                openid: "xxx",
                openkey: "openkey"
              })

            resolve(loginState)
          })
        }
      } else {
        // 成功获取cookie中的登录态
        return new Promise((resolve, reject) => {
          resolve(cookieState)
        })
      }
    } else {
      /**
       * 在QQ内直接拉取QQ登录态 || 在微信中，account=qq拉取qq登录态; account=wx拉取wx登录态
       * 暂时将account参数放在#后；因为微信php授权不能修改回调地址，但会删除#后参数。
       * @param getters
       * @param dispatch
       */
      return new Promise(async (resolve, reject) => {
        if (accountParam === "wxbean" && getters.isWX) {
          // 微信豆登陆态
          const exportkey = getParam("exportkey")
          if (location.hash.indexOf("wechat_redirect") !== -1) {
            location.hash = location.hash.replace(/(\/)?wechat_redirect/, "")
          }
          try {
            let loginState = userApi.getWxBeanSessionCookie()
            if (exportkey) {
              loginState = await userApi.getWxBeanLoginState({
                offer_id: getParam("offer_id"),
                export_key: exportkey
              })
              helper.removeParam("exportkey")
              userApi.setWxBeanSessionCookie(loginState)
            }
            const account = new CommonAccount(loginState)
            const results = await account.init(loginState)
            results && resolve(results.loginState)
          } catch (err) {
            console.log("errMsg: ", err)
            dispatch("setToastMsg", { toastMsg: ["登录失败", "请稍候重试"] }, { root: true })
            reject(
              new session_dummy({
                openid: "xxx",
                openkey: "openkey"
              })
            )
          }
        } else if (getters.thirdLoginState.openid && getters.thirdLoginState.openkey) {
          // 地址上传入登录态场景
          let loginState = getters.thirdLoginState
          try {
            const account = new CommonAccount(loginState)
            const results = await account.init(loginState)
            loginState = results && results.loginState
          } catch (error) {
            console.log(error)
          }
          // // 微信豆登录态
          // if (getters.thirdLoginState.session_type === "st_local_wechat") {
          //   loginState = new session_wxbean({
          //     appid: getters.thirdLoginState.wx_appid,
          //     openid: getters.thirdLoginState.openid,
          //     accessToken: getters.thirdLoginState.openkey
          //   })
          // }
          // // 第三方登录态
          // if (getters.thirdLoginState.session_type === "st_local_third_party") {
          //   loginState = new session_third({
          //     openid: getters.thirdLoginState.openid,
          //     openkey: getters.thirdLoginState.openkey
          //   })
          // }
          if (loginState) {
            resolve(loginState)
          } else {
            resolve(
              new session_dummy({
                openid: "xxx",
                openkey: "openkey"
              })
            )
          }
        } else if (window && window._msdkLoginParams) {
          let results = null
          try {
            const account = new MsdkAccount()
            results = await account.init()
          } catch (error) {
            console.log(error)
          }
          if (results && results.loginState) {
            resolve(results.loginState)
          } else {
            resolve(
              new session_dummy({
                openid: "xxx",
                openkey: "openkey"
              })
            )
          }
        } else if (getters.isQQ || accountParam === "qq") {
          let loginState = parseQQLogin(true)
          if (!getters.isBrowser) {
            loginState = await parsePskeyQQLogin({ s_url: location.href })
          }

          if (loginState) {
            resolve(loginState)
          } else {
            //若是失败了，则维持之前的登录态（微信登录态）【2. 用户两小时后刷新有account的地址，qq登录态失效】

            if (getters.isQQ) {
              let loginState = await parsePskeyQQLogin({ s_url: location.href })
              if (loginState) {
                resolve(loginState)
              } else {
                reject(loginState)
              }
            } else if (getters.isWX) {
              let loginState = parseWechatLogin()
              if (loginState) {
                resolve(loginState)
              } else {
                reject(loginState)
              }
            }
          }
        } else if (getters.isWX || accountParam === "wx") {
          // 浏览器下微信登录后还有account参数？ 会不会被授权干掉#后参数
          let loginState = parseWechatLogin()

          if (loginState) {
            resolve(loginState)
          } else {
            reject(loginState)
          }
        } else {
          // 非QQorWX的环境下首次打开页面 需要拉起登录弹窗， 登录后页面会带有account参数
          dispatch("midasH5Login")
          return new Promise((resolve, reject) => {
            resolve(
              new session_dummy({
                openid: "xxx",
                openkey: "openkey"
              })
            )
          })
        }
      })
    }
  },
  /**
   * 登陆态过期后清除cookie中的登陆态信息及sessionObj
   * 同时回到首页，重新加载页面，提示用户重新登录
   */
  removeLoginState({ getters, dispatch }) {
    dispatch("setToastMsg", { toastMsg: ["登陆态过期", "请重新登录"] }, { root: true })
    if (!getParam("openid") || !getParam("openkey")) {
      let sessiontype = getters.sessionObj.getSessionParam().session_type || ""
      switch (true) {
        case sessiontype === "skey":
          helper.removeCookie("uin", { domain: "qq.com" })
          helper.removeCookie("skey", { domain: "qq.com" })
          break
        case sessiontype.indexOf("pskey_") > -1:
          helper.removeCookie("p_uin")
          helper.removeCookie("p_skey")
          break
        case sessiontype === "st_local_wechat":
          helper.removeCookie("midas_txcz_openid")
          helper.removeCookie("midas_txcz_openkey")
          helper.removeCookie("midas_txcz_sessionid")
          helper.removeCookie("midas_txcz_sessiontype")
          helper.removeCookie("midas_txcz_wxAppid2")
          break
        default:
          break
      }
      setTimeout(() => {
        location.reload()
      }, 500)
    } else {
      // 外部传入登陆态，这里可以考虑将url中的登陆态删除
    }
    dispatch("setSessionObj", {})
  },
  /**
   * 手Q内只可转换QQ登录号； 微信内可切换qq/wx登录态
   * @param type qq or wx
   */
  async switchLoginState({ getters, dispatch }) {
    let url = getters.isQQ
      ? location.href.split("#")[0]
      : addParam({ account: "qq" }, delParam(["code", "aid", "state"], location.href.split("#")[0]))
    let loginState = await parsePskeyQQLogin({
      s_url: url
    })
    if (loginState) {
      cookies.del("p_uin")
      cookies.del("p_skey")
      location.replace(url)
    }
  },

  /**
   * 设置用户昵称和头像
   * @param state
   * @param getters
   * @param dispatch
   */
  setUserNickNameAndAvatar({ state, getters, dispatch }) {
    if (!helper.isObjectEmpty(getters.sessionObj) && getters.accountType) {
      if (getters.sessionObj.uin) {
        dispatch("setUserAvatar", `${location.protocol}//q.qlogo.cn/g?b=qq&nk=${getters.sessionObj.uin}&s=100`)
        userApi
          .getQQNickname()
          .then(res => {
            dispatch("setUserNickname", decodeURIComponent(res.nick))
          })
          .catch(err => {
            // console.log(err)
            Raven.captureException(err, {
              tag: { type: "user-module-catch-getQQNickname" },
              extra: {
                uin: getters.sessionObj.uin
              }
            })
          })
      } else if (getters.accountType === ACCOUNT_TYPE.WX || getters.accountType === ACCOUNT_TYPE.WX_BEAN) {
        let sessionObj = {}
        if (getters.accountType === ACCOUNT_TYPE.WX) {
          sessionObj = getters.sessionObj
        }
        // 微信豆中使用微信的登录态查询昵称和头像
        if (getters.accountType === ACCOUNT_TYPE.WX_BEAN && getters.isWX) {
          sessionObj = parseWechatLogin()
        }
        if (!helper.isObjectEmpty(sessionObj)) {
          userApi
            .getWechatNicknameAndAvatar(sessionObj)
            .then(resultinfo => {
              dispatch("setUserNickname", resultinfo.obj.nickname)
              dispatch("setUserAvatar", resultinfo.obj.headimgurl)
            })
            .catch(err => {
              // console.log(err)
              Raven.captureException(err, {
                tag: { type: "user-module-catch-getWechatNicknameAndAvatar" },
                extra: {
                  session: getters.sessionObj
                }
              })
            })
        }
      } else if (
        getters.accountType === ACCOUNT_TYPE.QQ &&
        getters.sessionObj.getSessionParam().session_type === "kp_accesstoken"
      ) {
        // https://graph.qq.com/user/get_user_info?access_token=0BEF1B136FEF536D712FD030F1A1F0BF&oauth_consumer_key=101502376&openid=F8CEC1A2A7AB0EC45B8D9E3331482A65
        let { openkey, qq_appid, openid } = getters.sessionObj.getSessionParam()
        if (openkey && qq_appid && openid) {
          userApi
            .getQQNickname()
            .then(resultinfo => {
              dispatch("setUserNickname", decodeURIComponent(resultinfo.nick))
              dispatch("setUserAvatar", `${location.protocol}//q.qlogo.cn/g?b=qq&nk=${resultinfo.provide_uin}&s=100`)
            })
            .catch(err => {
              // console.log(err)
              Raven.captureException(err, {
                tag: { type: "user-module-catch-getQQConnectNicknameAndAvatar" },
                extra: {
                  session: getters.sessionObj
                }
              })
            })
        } else {
          dispatch("setUserNickname", "游客")
        }
      }
    } else {
      dispatch("setUserNickname", "游客")
    }
  },

  /**
   * 调用方式new MidasH5Login(opt)
   * @param {Function} 可选 opt.onClose 点击关闭窗口时的回调
   * @param {Function} 可选 opt.beforeJump(accountType) 登录跳转前执行的方法 1、accountType枚举值为：QQ、WX 2、如果beforeJump => return false 则中断授权跳转
   * @param {String} 可选 opt.redirectUrl 指定登录回调地址
   * @param {String} 可选 opt.scope 指定微信授权scope，没有指定则默认snsapi_base
   * @return 实例
   * instance.close() 强制关闭弹窗。一般用不着，用户点击确定按钮后会自动关闭，除非需要非用户点击关闭
   * example1: 调用弹窗
   * new MidasH5Login({
   *   onClose(){}
   * });
   * example2: 如果需要强制关闭弹窗
   * var instance = new MidasH5Login({
   *   onClose(){}
   * });
   * instance.close()
   */
  midasH5Login() {
    let midasH5Login = new MidasH5Login({
      beforeJump: function(accountType) {
        return {
          redirectUrl: addParam(
            { account: accountType.toLowerCase() },
            delParam(["code", "aid", "state"], location.href.split("#")[0])
          )
        }
      },
      scope: "snsapi_userinfo",
      onClose: function() {}
    })
  },

  setSessionType({ dispatch }, sessionObj) {
    let sessiontype = sessionObj.getSessionParam().session_type
    switch (true) {
      case helper.isQQSessionType(sessiontype):
        dispatch("setAccountType", ACCOUNT_TYPE.QQ)
        return "qq"

      case sessiontype === "wc_actoken":
        dispatch("setAccountType", ACCOUNT_TYPE.WX)
        return "wx"

      case sessiontype === "st_dummy":
        dispatch("setAccountType", ACCOUNT_TYPE.DUMMY)
        return "dummy"

      // 微信豆
      case sessiontype === "st_local_wechat":
        dispatch("setAccountType", ACCOUNT_TYPE.WX_BEAN)
        return "wxbean"

      // 第三方登录态
      case sessiontype === "st_local_third_party":
        dispatch("setAccountType", ACCOUNT_TYPE.THIRD)
        return "third"

      default:
        return 0
    }
  },

  setSessionObj({ commit }, sessionObj) {
    commit(types.SET_SESSION_OBJ, sessionObj)
  },

  setUserNickname({ commit }, nickname) {
    commit(types.SET_USER_NICKNAME, nickname)
  },

  setUserAvatar({ commit }, imgUrl) {
    commit(types.SET_USER_AVATAR, imgUrl)
  },

  setAccountType({ commit }, accountType) {
    commit(types.SET_ACCOUNT_TYPE, accountType)
  }
}

const mutations = {
  [types.SET_SESSION_OBJ](state, sessionObj) {
    state.sessionObj = sessionObj
  },
  [types.SET_USER_NICKNAME](state, nickName) {
    state.nickName = nickName
  },
  [types.SET_USER_AVATAR](state, imgUrl) {
    state.avatar = imgUrl
  },
  [types.SET_ACCOUNT_TYPE](state, accountType) {
    state.accountType = accountType
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
